import * as Atom from '../recoil';
import { useRecoilState } from 'recoil';
import useToast from '../hooks/useToast';

export const useBaseParam = (
  callback: (params: any) => Promise<any>,
  condition?: object,
  options?: any
) => {
  const { addToast } = useToast();
  const [comm] = useRecoilState(Atom.personalInfo);
  const params = {
    trackCd: comm.trackCd,
    transactionNo: comm.transactionNo,
    authToken: comm.authToken,
    condition: { ...condition },
  };

  return async () => {
    if (callback) {
      const res: any = await callback(params);
      if (!res?.data?.isSucceed && res?.data?.resultMessage) {
        if (!options || !options.noToast)
          addToast(res?.data?.resultMessage);
      }
      return res;
    } else {
      return Promise.resolve();
    }
  };
};

export const useApi = () => {
  const { addToast } = useToast();
  const [comm] = useRecoilState(Atom.personalInfo);

  const withApiBase = (
    callback: (params: any) => Promise<any>,
    condition?: object,
  ) => {
    const params = {
      trackCd: comm.trackCd,
      transactionNo: comm.transactionNo,
      authToken: comm.authToken,
      condition: { ...condition },
    };

    return async () => {
      if (callback) {
        const res: any = await callback(params);
        if (!res?.data?.isSucceed && res?.data?.resultMessage) {
          if (res?.data?.resultCode !== 'E082' || res?.data?.resultCode !== '중복 요청 입니다.') {
            addToast(res?.data?.resultMessage);
          }
        }
        return res;
      } else {
        return Promise.resolve();
      }
    };
  };
  return {
    withApiBase,
  };
};
